import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const CenteredTemplateOneOneThree = ({
  titleText = "Complete Growth Bundle",
  titleFont = "Montserrat",
  titleFontSize = "31",
  titleColor = "#54157C",
  titleTextAlign = "center",
  titleIsBold = true,
  titleIsItalic = false,
  titleIsUnderline = false,

  secondaryTitleText = "Course access\nMentoring\nTemplates",
  secondaryTitleFont = "Montserrat",
  secondaryTitleFontSize = "25",
  secondaryTitleColor = "#485299",
  secondaryTitleTextAlign = "center",
  secondaryTitleIsBold = true,
  secondaryTitleIsItalic = false,
  secondaryTitleIsUnderline = false,

  subtitleText = "Save 25% today.",
  subtitleFont = "Montserrat",
  subtitleFontSize = "19",
  subtitleColor = "#FEF7EC",
  subtitleTextAlign = "center",
  subtitleIsBold = true,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  buttonLabel = "Start Today",
  buttonFont = "Poppins",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "19",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#54157C",

  backgroundType = "color",
  backgroundColor = "#7C82C8",
  backgroundImage = null,
  backgroundImagePreview,

  contentImageOne = null,
  contentImageOnePreview = null,

  inmeeting = false,
  center = false,
  preview = false,
  onClose,
}) => {
  if (
    (backgroundImage && ![null, "null"].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
      className={`relative ${
        !inmeeting ? "h-auto min-h-[283px]" : center ? "!h-[50vh]" : "!h-[15vh]"
      } w-full flex flex-col mx-auto items-center justify-between px-4 md:px-8 py-4 md:py-3 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90 z-0"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative z-10 flex flex-col h-full w-full justify-between items-center gap-4 md:gap-5">
        {/* Title Section */}
        <div className="flex items-center justify-center w-full">
          <h1
            className={`text-center ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            } leading-snug max-w-full px-4`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont,
              textAlign: titleTextAlign,
              fontWeight: explicitBoleanCheck(titleIsBold) ? 900 : "normal",
              letterSpacing: "-0.923px",
            }}
          >
            {titleText}
          </h1>
        </div>

        {/* Middle Section - Image and Secondary Title */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 lg:gap-7 w-full">
          {/* Image */}
          <div className="flex-shrink-0">
            {contentImageOne || contentImageOnePreview ? (
              <img
                src={
                  contentImageOne instanceof File
                    ? contentImageOnePreview
                    : contentImageOne
                }
                alt="Product"
                className="w-32 h-20 md:w-40 md:h-24 object-cover"
              />
            ) : (
              <svg
                width="158"
                height="97"
                viewBox="0 0 158 97"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="w-32 h-20 md:w-40 md:h-24"
              >
                <g clipPath="url(#clip0_1789_18863)">
                  <path d="M158 0H0V97H158V0Z" fill="#898989" />
                  <path
                    d="M91.2678 66.5681H64.5556C63.1139 66.32 61.8248 65.5344 61.1455 64.2251C60.8821 63.7152 60.7712 63.2328 60.6465 62.6815V36.1229C60.9653 34.028 62.5872 32.4293 64.7358 32.2363H91.046C93.2917 32.4017 95.0244 34.1383 95.1908 36.3572V62.5161C95.0383 64.5559 93.3333 66.3614 91.2817 66.5819L91.2678 66.5681ZM93.1531 50.9389V36.4124C93.1531 35.3374 91.8916 34.221 90.8242 34.2348H65.1101C63.9872 34.1659 62.6565 35.2822 62.6565 36.4124V55.8317L67.9934 51.3111C69.4489 50.2498 70.544 50.5255 71.8609 51.5454C72.8867 52.331 73.857 53.2406 74.869 54.0675L75.0215 54.0951L84.4477 44.7369C85.8616 43.6757 87.2894 43.9651 88.4261 45.2055C89.9787 46.9145 91.3371 48.9819 92.8897 50.7046C92.959 50.7873 93.056 50.8976 93.1531 50.9389ZM86.0557 46.1151C85.5982 46.2116 84.5586 47.5071 84.1843 47.8793C81.4257 50.6633 78.6117 53.3784 75.8532 56.1624C75.4928 56.5208 74.9522 56.631 74.5086 56.3554L70.2806 52.8547C70.0588 52.7031 69.8648 52.6342 69.5875 52.7031L62.6981 58.4641C62.7812 60.7106 61.8109 64.294 65.0546 64.5697H90.7688C92.0996 64.487 93.0422 63.5773 93.1669 62.2542V54.2191L86.7211 46.3356C86.5409 46.1703 86.3052 46.0876 86.0695 46.1427L86.0557 46.1151Z"
                    fill="#606060"
                  />
                  <path
                    d="M71.0162 36.4672C74.9115 36.0951 77.67 40.1471 75.8402 43.6202C74.0381 47.052 68.9646 47.0383 67.1626 43.6202C65.5684 40.5744 67.5646 36.8118 71.0024 36.481L71.0162 36.4672ZM71.3489 38.4794C67.5368 38.6862 67.8972 44.5437 71.8618 44.1578C75.3689 43.8132 75.0639 38.2727 71.3489 38.4794Z"
                    fill="#606060"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1789_18863">
                    <rect width="158" height="97" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            )}
          </div>

          {/* Secondary Title Text */}
          <div className="flex items-center justify-center">
            <h2
              className={`text-center ${
                explicitBoleanCheck(secondaryTitleIsBold) ? "font-bold" : ""
              } ${
                explicitBoleanCheck(secondaryTitleIsItalic) ? "italic" : ""
              } ${
                explicitBoleanCheck(secondaryTitleIsUnderline)
                  ? "underline"
                  : ""
              } leading-snug whitespace-pre-line`}
              style={{
                color: secondaryTitleColor,
                fontSize: `${secondaryTitleFontSize}px`,
                fontFamily: secondaryTitleFont,
                textAlign: secondaryTitleTextAlign,
                fontWeight: explicitBoleanCheck(secondaryTitleIsBold)
                  ? 700
                  : "normal",
              }}
            >
              {secondaryTitleText}
            </h2>
          </div>
        </div>

        {/* Bottom Section - Subtitle and Button */}
        <div className="flex flex-col items-center justify-center gap-3 w-full">
          {/* Subtitle */}
          <p
            className={`text-center ${
              explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: subtitleColor,
              fontSize: `${subtitleFontSize}px`,
              fontFamily: subtitleFont,
              textAlign: subtitleTextAlign,
              fontWeight: explicitBoleanCheck(subtitleIsBold) ? 700 : "normal",
            }}
          >
            {subtitleText}
          </p>

          {/* Button */}
          <button
            className={`px-8 py-3 md:px-10 md:py-3 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl ${
              explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(buttonIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""
            } ${
              buttonLink ? "cursor-pointer hover:opacity-90" : "cursor-default"
            }`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont,
              borderRadius: "27px",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CenteredTemplateOneOneThree;
